import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '../../../../core/services/helpers.service';
import { MatDialog } from '@angular/material/dialog';
import { ExpanseCategoryService } from '../../../../core/api/expanse-category.service';
import { UserService } from '../../../../core/api/user.service';
import { TeamService } from '../../../../core/api/team.service';
import { FileService } from '../../../../core/api/file.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import { LoadingService } from '../../../../core/services/loading.service';
import { DirectiveModule } from '../../../../core/directives';
import { AuthService } from '../../../../core/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-action-expense-category',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatDividerModule,
    CdkDropList,
    CdkDrag,
    MatRadioModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    DirectiveModule,
  ],
  templateUrl: './action-expense-category.component.html',
  styleUrl: './action-expense-category.component.scss',
})
export class ActionExpenseCategoryComponent implements OnInit {
  m: any;
  id: any;
  form: FormGroup;
  teams: any[] = [];
  allUser: any[] = [];
  financeUser: any[] = [];
  currentData: any;

  canSelectApprovalUser: any[] = [];
  canSelectVerificatorUser: any[] = [];
  canSelectFinanceUser: any[] = [];

  selectedApprovalUser: any[] = [];
  selectedVerificatorUser: any[] = [];
  selectedFinanceUser: any[] = [];

  type: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private helpers: HelpersService,
    private fb: FormBuilder,
    private router: Router,
    private service: ExpanseCategoryService,
    private dialog: MatDialog,
    private userService: UserService,
    private teamService: TeamService,
    private fileService: FileService,
    private loadingService: LoadingService,
    private authService: AuthService
  ) {
    this.m = this.activatedRoute.snapshot.queryParams['m'];
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.form = this.fb.group({
      name: [null, [Validators.required]],
      type: [null, [Validators.required]],
      icon: [null, [Validators.required]],
      budget_period: [0, [Validators.required]],
      budget_amount: [0, [Validators.required]],
      max_transaction_per_period: [0, [Validators.required]],
      is_using_max: [false],
      max_transaction_value: [0, [Validators.required]],
      request_receipt_image: [false, [Validators.required]],
      own_approval_flow: [false, [Validators.required]],
      assign_specific_teams: [false, [Validators.required]],
      approval_sequence: [true, [Validators.required]],
      approval_note: [false, [Validators.required]],
      approval_upload_file: [false, [Validators.required]],
      teams: [[]],
      approval_flow: [[]],
      verification_custom_flow: [null],
      verification_sequence: [null],
      verification_flow: [[]],
      finance_all: [true, [Validators.required]],
      finance_user: [null],
    });
  }

  changeMaxValue(data: any): void {
    if (!data.checked) {
      this.form.get('max_transaction_value')?.setValue(0);
    }
  }

  ngOnInit(): void {
    this.loadingService.startLoading();

    // Jalankan semua proses asynchronous secara paralel
    const usersPromise = this.getAllUsers();
    const teamsPromise = this.getAllTeams();
    const dataByIdPromise = this.getDataById();

    // Tunggu semua proses selesai
    Promise.all([usersPromise, teamsPromise, dataByIdPromise])
      .then(([a, b, data]: [any, any, any]) => {
        this.currentData = data;
        this.type = this.currentData.type;
        this.form.patchValue(data);
        if (this.form.get('max_transaction_value')?.value > 0) {
          this.form.get('is_using_max')?.setValue(true);
        }
        if (data.expanse_category_flows.length) {
          for (const item of data.expanse_category_flows.filter(
            (item: any) => item.category == 'APPROVAL'
          ).sort((a: any, b: any) => a.order - b.order)) {
            this.addApprovalUser(item.user?.id);
          }
        }
        if (data.expanse_category_verificator_flows.length) {
          for (const item of data.expanse_category_verificator_flows.filter(
            (item: any) => item.category == 'VERIFICATION'
          ).sort((a: any, b: any) => a.order - b.order)) {
            this.addVerificatorUser(item.user?.id);
          }
        }
        if (data.expanse_category_teams.length) {
          this.form.get('teams')?.setValue(
            data.expanse_category_teams.map((item: any) => {
              return item.team?.id;
            })
          );
        }
        if (data.finance_user) {
          this.addFinanceUser(data.finance_user.id, true);
          this.form.get('finance_user')?.setValue(data.finance_user.id);
        }
      })
      .finally(() => {
        this.loadingService.endLoading();
      });
  }

  getDataById(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.id) {
        this.form.get('type')?.disable();
        this.service.getById(this.id).then(
          (data) => {
            resolve(data);
          },
          (error) => {
            this.helpers.sbError(error.message);
            reject(error);
          }
        );
      } else {
        resolve();
      }
    });
  }

  getAllUsers(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userService.getAllData().then(
        (res) => {
          res.forEach((item: any) => {
            this.getImageUrl(item);
          });
          this.allUser = res;
          this.canSelectApprovalUser = res.filter((item: any) =>
            this.authService.isApprover(item)
          );
          this.canSelectVerificatorUser = res.filter((item: any) =>
            this.authService.isApprover(item)
          );
          this.financeUser = res.filter((item: any) =>
            this.authService.isFinance(item)
          );
          this.canSelectFinanceUser = this.financeUser;
          resolve();
        },
        (error) => {
          this.helpers.sbError(error.message);
          reject(error);
        }
      );
    });
  }

  getAllTeams(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.teamService.getAllData().then(
        (res) => {
          this.teams = res;
          resolve();
        },
        (error) => {
          this.helpers.sbError(error.message);
          reject(error);
        }
      );
    });
  }

  private getImageUrl(item: any) {
    if (item.file) {
      this.loadingService.startLoading();
      this.fileService.download(item.file?.id).subscribe(
        (res) => {
          this.loadingService.endLoading();
          item['imageUrl'] = URL.createObjectURL(res);
        },
        (error) => {
          this.loadingService.endLoading();
          // this.helpers.sbError(error.message);
        }
      );
    } else {
      item['imageUrl'] = null;
    }
  }

  addApprovalUser(id: any) {
    const selectedUser = this.canSelectApprovalUser.filter(
      (item) => item.id == id
    );
    this.canSelectApprovalUser = this.canSelectApprovalUser.filter(
      (item) => item.id != id
    );
    this.selectedApprovalUser.push(...selectedUser);
    this.form.get('approval_flow')?.setValue(
      this.selectedApprovalUser.map((item) => {
        return item.id;
      })
    );
  }

  removeApprovalUser(id: any) {
    const selectedUser = this.selectedApprovalUser.filter(
      (item) => item.id == id
    );
    this.selectedApprovalUser = this.selectedApprovalUser.filter(
      (item) => item.id != id
    );
    this.canSelectApprovalUser.push(...selectedUser);
    this.form.get('approval_flow')?.setValue(
      this.selectedApprovalUser.map((item) => {
        return item.id;
      })
    );
  }

  addVerificatorUser(id: any) {
    const selectedUser = this.canSelectVerificatorUser.filter(
      (item) => item.id == id
    );
    this.canSelectVerificatorUser = this.canSelectVerificatorUser.filter(
      (item) => item.id != id
    );
    this.selectedVerificatorUser.push(...selectedUser);
    this.form.get('verification_flow')?.setValue(
      this.selectedVerificatorUser.map((item) => {
        return item.id;
      })
    );
  }

  removeVerificatorUser(id: any) {
    const selectedUser = this.selectedVerificatorUser.filter(
      (item) => item.id == id
    );
    this.selectedVerificatorUser = this.selectedVerificatorUser.filter(
      (item) => item.id != id
    );
    this.canSelectVerificatorUser.push(...selectedUser);
    this.form.get('verification_flow')?.setValue(
      this.selectedVerificatorUser.map((item) => {
        return item.id;
      })
    );
  }

  addFinanceUser(id: any, isEdit = false) {
    if (!this.form.get('finance_user')?.value || isEdit) {
      const selectedUser = this.canSelectFinanceUser.filter(
        (item) => item.id == id
      );
      this.canSelectFinanceUser = this.canSelectFinanceUser.filter(
        (item) => item.id != id
      );
      this.selectedFinanceUser.push(...selectedUser);
      this.form.get('finance_user')?.setValue(id);
    }
  }

  removeFinanceUser(id: any) {
    if (this.form.get('finance_user')?.value) {
      const selectedUser = this.selectedFinanceUser.filter(
        (item) => item.id == id
      );
      this.selectedFinanceUser = this.selectedFinanceUser.filter(
        (item) => item.id != id
      );
      this.canSelectFinanceUser.push(...selectedUser);
      this.form.get('finance_user')?.setValue(null);
    }
  }

  dropApprovalUser(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.selectedApprovalUser,
      event.previousIndex,
      event.currentIndex
    );
  }

  dropVerificatorUser(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.selectedVerificatorUser,
      event.previousIndex,
      event.currentIndex
    );
  }

  uncheckApprovalRemarks() {
    this.form.get('approval_note')?.setValue(false);
    this.form.get('approval_upload_file')?.setValue(false);
  }

  submit() {
    if (this.form.valid) {
      const data = this.form.value;
      if (data.verification_custom_flow == false) {
        data.verification_flow = data.approval_flow;
        data.verification_sequence = data.approval_sequence;
      } else if (data.verification_custom_flow == null) {
        data.verification_flow = [];
      }
      data.max_transaction_value = this.helpers.parseAmount(
        data.max_transaction_value
      );
      this.dialog
        .open(ConfirmDialogComponent, {
          width: '545px',
          maxHeight: '95vh',
          panelClass: 'confirm-dialog',
          data: {
            title: `Confirm ${
              this.m == 'add'
                ? 'Add New Expense Category'
                : 'Edit Expense Category'
            }`,
            message: `Changes to the Expense Category cannot be undone once saved. Are you sure you want to proceed?`,
          },
        })
        .afterClosed()
        .subscribe((result: any) => {
          if (result) {
            if (this.m == 'add') {
              this.loadingService.startLoading();
              this.service
                .insert(data)
                .then(() => {
                  this.loadingService.endLoading();
                  this.helpers.sbSuccess(
                    'Expense Category berhasil ditambahkan!'
                  );
                  this.router.navigate(['/dashboard/expense-category']);
                })
                .catch((error) => {
                  this.loadingService.endLoading();
                  this.helpers.sbError(error.message);
                });
            } else if (this.m == 'edit' && this.id) {
              data['type'] = this.currentData.type;
              this.loadingService.startLoading();
              this.service
                .updateById(this.id, data)
                .then(() => {
                  this.loadingService.endLoading();
                  this.helpers.sbSuccess(
                    'Expense Category berhasil diperbarui!'
                  );
                  this.router.navigate(['/dashboard/expense-category']);
                })
                .catch((error) => {
                  this.loadingService.endLoading();
                  this.helpers.sbError(error.message);
                });
            }
          }
        });
    } else {
      this.helpers.sbError('Lengkapi form terlebih dahulu!');
    }
  }

  cancel() {
    this.router.navigate(['/dashboard/expense-category']);
  }
}
